import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ajaxNewMwebPreUrl } from '@/config';
import axios from 'axios';
import User from 'drip/user';
import { isProd } from '@/utils/openApp';
export var preFetchShowsAPI = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axios.post("".concat(ajaxNewMwebPreUrl, "/project/preLoadShows"), {
            projectId: id,
            client: 2 // 客户端 1:WEB 2:APP(传2)
          });

        case 2:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function preFetchShowsAPI(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getShowInfoApi = /*#__PURE__*/function () {
  var _getShowInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return axios.post("".concat(ajaxNewMwebPreUrl, "/project/shows"), {
            projectId: id,
            client: 2 // 传2代表要获取座位图URL
          });

        case 2:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  function getShowInfo(_x2) {
    return _getShowInfo.apply(this, arguments);
  }
  return getShowInfo;
}();
export var getCalendarTag = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return axios.get("".concat(ajaxNewMwebPreUrl, "/calendar/tag"));
        case 2:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getCalendarTag() {
    return _ref2.apply(this, arguments);
  };
}();
export var getJumpInfo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
    var projectId;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          projectId = _ref3.projectId;
          _context4.next = 3;
          return axios.get("".concat(ajaxNewMwebPreUrl, "/project/jumpInfo?projectId=").concat(projectId, "&detailType=1"));
        case 3:
          return _context4.abrupt("return", _context4.sent);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getJumpInfo(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
export var getDateCardApi = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return axios.post("".concat(ajaxNewMwebPreUrl, "/project/shows/dateCard"), {
            projectId: projectId
          });
        case 2:
          return _context5.abrupt("return", _context5.sent);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getDateCardApi(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
export var taskReportApi = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var baseUrl, queryString, url;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          baseUrl = "https://".concat(isProd ? 'api.maoyan.com/sns' : 'm.51ping.com/api/sns', "/user/view.json");
          queryString = new URLSearchParams(params).toString();
          url = queryString ? "".concat(baseUrl, "?").concat(queryString) : baseUrl;
          _context6.next = 5;
          return axios({
            url: url,
            method: 'post',
            headers: {
              'Content-type': 'application/x-www-form-urlencoded',
              'Token': User.token
            }
          });
        case 5:
          return _context6.abrupt("return", _context6.sent);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function taskReportApi(_x5) {
    return _ref6.apply(this, arguments);
  };
}();
export var fansTaskReportApi = function fansTaskReportApi(params) {
  var baseUrl = "https://".concat(isProd ? 'api.maoyan.com/sns' : 'm.51ping.com/api/sns', "/user/click.json");
  var queryString = new URLSearchParams(params).toString();
  var url = queryString ? "".concat(baseUrl, "?").concat(queryString) : baseUrl;
  return axios({
    url: url,
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
      'Token': User.token
    }
  });
};